
import { defineComponent } from 'vue';
import { mdiMagnify } from '@mdi/js';
import Icon from '../Icon.vue';
import { getModule } from 'vuex-module-decorators';
import SignageState, { ISignageState } from '../../store/modules/signage';

let signageState = {} as ISignageState;

export default defineComponent({
    name: "Zone Weather",
    data: ()=>({
        content: { } as any,
        locations: [] as any[],
        editLocation: false,
        newLocation: '',
        mdiMagnify,
        defaultLocation: {
            country: "United States of America",
            id: 2629508,
            lat: 40.88,
            lon: -81.4,
            name: "North Canton",
            region: "Ohio",
            url: "north-canton-ohio-united-states-of-america"
        }
    }),

    components: {
        Icon
    },

    methods: {
        async searchLocations(location: any, cb: any) {
            if(location !== '') {  
                const locationResponse = await signageState.getWeatherLocations(location);
                if(locationResponse.data) {  
                    cb(locationResponse.data);
                }
            }
             else {
                 this.locations = [];
             }
        },

        handleLocationSelect(location: any) {
            this.newLocation = location
            this.content.location = location;
            this.editLocation = false;
            this.newLocation = '';
        },

        onEditLocation() {
            if(this.editLocation) {
                this.editLocation = false;
                this.newLocation = '';
            }
            else {
                this.editLocation = true;
            }
        }
    },

    props: {
        zoneContent: {
            type: Object,
            default: null
        },
        zoneNumber: {
            type: Number,
            default: null
        },
        zoneType: {
            type: String,
            default: null
        },
        contentName: {
            type: String,
            default: null
        }
    },

    async created() {
        signageState = getModule(SignageState);

        this.content = {
            temperatureScale: this.zoneContent && this.zoneContent.content.temperatureScale ? this.zoneContent.content.temperatureScale : 'Fahrenheit',
            location: this.zoneContent && this.zoneContent.content.location ? this.zoneContent.content.location : this.defaultLocation
}
    },

   watch: {
    content: {
        handler(newValue: any) {
        const current = this.zoneContent?.content ?? {};
        if (JSON.stringify(newValue) !== JSON.stringify(current)) {
            this.$emit('updateSignageZones', {
            zoneNumber: this.zoneNumber,
            zoneType: this.zoneType,
            updatedContent: newValue
            });
        }
        },
        deep: true
    },
    zoneContent: {
        immediate: true,
        deep: true,
        handler(newVal) {
        if (!newVal || typeof newVal !== 'object' || !newVal.content) {
            this.content = {
            temperatureScale: 'Fahrenheit',
            location: this.defaultLocation
            };
            return;
        }

        const content = newVal.content;

        const newVals = {
            temperatureScale: content.temperatureScale ?? 'Fahrenheit',
            location: content.location ?? this.defaultLocation
        };

        if (JSON.stringify(this.content) !== JSON.stringify(newVals)) {
            this.content = newVals;
        }
        }
    }
    }

    })
